<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JSTEof/tc-custom/9781626811270.jpg?1734329398315" alt="This image is the cover for the book Portrait of a Married Woman"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Portrait of a Married Woman
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A dissatisfied wife is tempted by another man in this novel by the <i>New York Times</i>–bestselling author of <i>Out of the Blue</i>: “A wonderful writer” (Luanne Rice, author of <i>The Secret Language of Sisters</i>).</b><br/>  <br/> After seventeen years of marriage, Maggie Hollander seems like she has it all. Her husband, Matthew, still loves her deeply, and two irrepressible children complete the picture-perfect family in their elegant New York apartment.<br/>  <br/> But at thirty-eight, Maggie has questions about herself that grow deeper and more disturbing. Once a promising artist, she decides to return to art class in search of answers. It is there she meets a sculptor who rekindles her talent—and her passion. David Golden will expose Maggie to a tenderness that is as liberating as it is dangerous, and will carry her toward an unforeseen choice . . .<br/>  <br/> “A living, breathing portrait of a truly contemporary woman . . . A lovely read.” —Barbara Taylor Bradford, <i>New York Times–</i>bestselling author of <i>Voice of the Heart</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sally Mandel
      </h2>
      
      <p class="authorDescription body article">Sally Mandel is the author of seven novels: <I>Heart and Soul</I>, <I>Out of the Blue</I>, <I>A Time to Sing</I>, <I>Portrait of a Married Woman<I>, <I>Quinn</I>, <I>Change of Heart</I>, </I></I>and&#160;<I><I><I>Take Me Back</I>. <I>Change of Heart&#160;</I></I></I>was on the <I><I><I>New York Times&#160;</I></I></I>bestseller list for ten weeks. The film rights were sold to Columbia Pictures.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?15611a96